import React from 'react';
import { useT } from './lang.js';

/**
 * Dönen bekleme halkası.
 *
 * NEDEN: iskelet (Skeleton.jsx) henüz GELMEMİŞ bir sayfanın kalıbını çizer;
 * bu bileşen ise BASILMIŞ bir düğmenin işini sürdürdüğünü söyler. Masa
 * kapatma sunucuda kilit alır ve bir saniye sürebilir — o bir saniyede hiçbir
 * şey dönmezse kasiyer düğmeye ikinci kez basıyor.
 *
 * Rengi `currentColor`: koyu birincil düğmenin içinde de, salon kartının
 * silik yazısında da kendiliğinden doğru tonda çıkar.
 */
export default function Spin({ label }) {
  const t = useT();
  const txt = label || t('loading');
  return <span className="spin" role="status" aria-label={txt} title={txt} />;
}
